import { Outlet } from 'react-router-dom'
import SubMenu from '../../components/SubMenu'

const HomeConfig = () => {
  const subMenuItems = [
    {
      label: 'Auditar Visita',
      path: '/Configuracoes/visitas'
    },
    {
      label: 'Editar Visita',
      path: '/Configuracoes/editar'
    },
    {
      label: 'Criar Visita',
      path: '/Configuracoes/formulario'
    },

    // ... outros itens
  ]

  return (
    <>
      <div className='home-container'>
        <div className='home-content'>
          <div className='home-conteudo-pagina'>
            <SubMenu menuItems={subMenuItems} />
            <Outlet /> {/* Isso renderizará as sub-rotas */}
          </div>
        </div>
      </div>
    </>
  )
}

export default HomeConfig
